<template>
    <div class="wrap">
        <div class="box" :style="{ width: current_width + '%' }"></div>
    </div>
</template>

<script>
export default {
    name: "loading",
    data() {
        return {
            current_width: this.$store.state.loading_sum,
        };
    },
    created() {
        let begin = setInterval(() => {
            this.current_width = this.current_width + Math.random() * 10;
            if (this.current_width > 90) {
                clearInterval(begin);
            }
        }, 666);
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    border-radius: 15px;
    overflow: hidden;
}
.box {
    // width: 50%;
    height: 4px;
    border-radius: 15px;
    background: -webkit-repeating-linear-gradient(
        30deg,
        #FFB7B7 0,
        #FFB7B7 10px,
        #FFABAB 10px,
        #FFABAB 20px
    );
    -webkit-animation: move 5s linear infinite;

    transition: all 0.4s ease-in 0.4s;
}
@-webkit-keyframes move {
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: -200px 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue